import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left why-Adobe-document-services" mdxType="TitleBlock" />
    <h2 {...{
      "id": "why-adobe-acrobat-services"
    }}>{`Why Adobe Acrobat Services?`}</h2>
    <TextBlock slots="image, text" width="33%" theme="lightest" className="align-left enterprise-icon-xl-size horizontal-align-heading py-0" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/1dc4846e987ea3f890077a13b9fa39e7/2_Icon_modify-pages.svg",
        "alt": "Build custom document workflows",
        "title": " "
      }}></img></p>
    <p>{`Choose from 15+ APIs to build custom document workflows.`}</p>
    <TextBlock slots="image, text" width="33%" theme="lightest" className="align-left enterprise-icon-xl-size horizontal-align-heading py-0" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/d81ed14dcdf4ae7fa3edc796fdf00990/2_Icon_protect.svg",
        "alt": "Enjoy enterprise-grade",
        "title": " "
      }}></img></p>
    <p>{`Enjoy enterprise-grade security, reliability, and scalability.`}</p>
    <TextBlock slots="image, text" width="33%" theme="lightest" className="align-left enterprise-icon-xl-size horizontal-align-heading py-0" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/a2cb06d6bb01c10afe3d86b4fb8b254f/2_Icon_platform-agnostic.svg",
        "alt": "Get high quality PDF",
        "title": " "
      }}></img></p>
    <p>{`Get high quality PDF outputs for compatibility and interoperability.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      